import {
  ApiResponse,
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  getToken,
  User,
} from "@/scripts/Common";

import {
  CreateIssuerIdentityUserRequest,
  FetchIssuerIdentityUsersParam,
} from "@/components/issuers/scripts/issuerIdentityUsers";

const fetchIssuerIdentityUsers = async (args: FetchIssuerIdentityUsersParam, abortSignal? : AbortSignal): Promise<ApiResponse<User[]>> => {
  const {
    response,
    error,
    paginationCount,
    paginationLimit,
    paginationPage,
    totalItemCount
  } = await defaultFetch({
    apiName: 'issuerIdentityUsers',
    bearer: getToken(),
    options: {
      query: {
        pageSize: args?.pageSize,
        email: args?.email,
        sortColumn: args?.sortColumn,
        sortDirection: args?.sortDirection,
        pageNumber: typeof args?.pageNumber === 'number' ? args.pageNumber - 1 : undefined, // reduce by 1 to make it 0 based
      },
      routeParams: {
        issuerId: args.issuerId.toString(10)
      },
      abortSignal
    }
  });

  return {
    response,
    error,
    paginationCount,
    paginationLimit,
    paginationPage,
    totalItemCount
  }
}

const createIssuerIdentityUser = async (issuerId: number, createUserRequest: CreateIssuerIdentityUserRequest, abortSignal? : AbortSignal)=> {
  const {error} = await defaultFetch({
    apiName: 'issuerIdentityUsers',
    bearer: getToken(),
    body: JSON.stringify(createUserRequest),
    options: {
      method: httpMethod.POST,
      routeParams: {
        issuerId: issuerId.toString(10)
      },
      abortSignal
    }
  });

  return {
    error
  }
}

export {
  fetchIssuerIdentityUsers,
  createIssuerIdentityUser
}
